import React, { useState, useEffect } from "react";
import LogoNav from "../Assets/LogoNav";
import { Link, useLocation } from "react-router-dom";

import {
  LinkHome,
  LinkQuienesSomos,
  LinkProductos,
  LinkOperacion,
  LinkContacto,
  LinkLinkedinIcon,
} from "../Assets/Variables";

// Mapas de rutas ES <-> EN
const ES_TO_EN = {
  "/": "/en",
  "/quienes-somos": "/en/about",
  "/productos": "/en/products",
  "/nuestra-operacion": "/en/operation",
  "/contacto": "/en/contact",
};

const EN_TO_ES = {
  "/": "/",
  "/about": "/quienes-somos",
  "/products": "/productos",
  "/operation": "/nuestra-operacion",
  "/contact": "/contacto",
};

const NavBar = () => {
  const getIsMobile = () =>
    typeof window !== "undefined" ? window.innerWidth <= 1023 : false;

  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(getIsMobile());

  const location = useLocation();
  const pathname = location.pathname;
  const isEnglish = pathname.startsWith("/en");

  // Normalizo ruta actual sin prefijo
  const leaf = isEnglish
    ? pathname.replace(/^\/en(\/|$)/, "/") || "/"
    : pathname;

  // Ruta equivalente en el otro idioma
  const switchPath = isEnglish
    ? EN_TO_ES[leaf] ?? "/"
    : ES_TO_EN[leaf] ?? "/en";

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? (
    <nav>
      <div className="navbar">
        <div className="navbar-buttons">
          <button className="svg" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
              </svg>
            )}
          </button>

          {/* Logo: ahora usa prop to */}
          <LogoNav to={isEnglish ? "/en" : "/"} />

          {/* Botón switch de idioma */}
          <Link to={switchPath} className="idioma">
            {isEnglish ? "ES" : "EN"}
          </Link>
        </div>
      </div>

      <div
        className={isOpen ? "buttons-open" : "buttons-closed"}
        onClick={() => setIsOpen(!isOpen)}
      >
        <LinkHome />
        <LinkQuienesSomos />
        <LinkProductos />
        <LinkOperacion />
        <LinkContacto />
        <div className="social">{LinkLinkedinIcon}</div>
      </div>
    </nav>
  ) : (
    <nav>
      <div className="navbar">
        <div className="navbar-buttons">
          {/* Logo: ahora usa prop to */}
          <LogoNav to={isEnglish ? "/en" : "/"} />

          <div className="navbar-home-menu">
            <LinkHome />
            <LinkQuienesSomos />
            <LinkProductos />
            <LinkOperacion />
            <LinkContacto />
          </div>

          {/* Botón switch de idioma */}
          <Link to={switchPath} className="idioma">
            {isEnglish ? "ES" : "EN"}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
